import { HTTPError } from "ky";

type CardPreviewErrorKind = "missing-route" | "not-presentable" | "unavailable";

function cardPreviewErrorKind(error: unknown): CardPreviewErrorKind {
	if (!(error instanceof HTTPError)) {
		return "unavailable";
	}

	if (error.response.status === 403) {
		return "not-presentable";
	}

	if (error.response.status === 404) {
		return "missing-route";
	}

	return "unavailable";
}

export function cardPreviewErrorHintKey(error: unknown): string {
	switch (cardPreviewErrorKind(error)) {
		case "not-presentable":
			return "users.cardNotPresentableHint";
		case "missing-route":
			return "users.cardEndpointMissingHint";
		default:
			return "users.cardUnavailableHint";
	}
}
